import * as actionTypes from '../actionTypes';

export const initTemplates = templates => ({ type: actionTypes.templates.INIT, templates });
export const setTemplate = template => ({ type: actionTypes.templates.SET, template });
export const deleteTemplate = templateId => ({ type: actionTypes.templates.DELETE, templateId });